<script lang="ts">
	import ValueType from './ValueType.svelte'
	import { isAlignCenter, isAlignRight } from './helpers'
	import type { Column } from './types'

	interface Props {
		column: Column<any>
		row: any
	}

	let { column, row }: Props = $props()
</script>

{#if column}
	<td
		class="
      {column.class || ''} {isAlignRight(column.type)
			? 'text-right'
			: isAlignCenter(column.type)
				? 'text-center'
				: ''}
      group-[.is-row-selected]:border-y-primary-500
      first:group-[.is-row-selected]:border-l-primary-500 last:group-[.is-row-selected]:border-r-primary-500 border border-gray-200 border-t-transparent border-l-transparent px-4 py-2 whitespace-nowrap
      first:pl-9
      last:border-r-transparent
      last:pr-9
      dark:border-gray-500
      dark:border-t-transparent dark:border-l-transparent
    "
	>
		<ValueType {column} {row} />
	</td>
{:else}
	<td>&ndash;</td>
{/if}
